import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import { scheduleReducer } from './slices/scheduleSlice';
import { metricReducer } from './slices/metricSlice';
import { notificationReducer } from './slices/notificationSlice';
import { errorReducer } from './slices/errorSlice';
import { mappedFieldsReducer } from './slices/mappedSlice';


const store = configureStore({
  reducer: {
    auth: authReducer,
    schedule:scheduleReducer,
    metrics:metricReducer,
    notification:notificationReducer,
    error:errorReducer,
    mappedFields:mappedFieldsReducer,
  },
});

export default store;
